import { chunk, isEmpty, fromPairs } from 'lodash'
import firebase from 'firebase/app'
import 'firebase/firestore'
import types from './types'

export default {
  [types.actions.fill]: context => {
    if (!isEmpty(context.state.postIDs.nl)) return
    const t = x => fromPairs(chunk(x.data().ids, 2))
    firebase.firestore().collection('i18n').doc('nl').get().then(nl => {
      firebase.firestore().collection('i18n').doc('fr').get().then(fr => {
        const data = { nl: t(nl), fr: t(fr) }
        context.commit(types.mutations.setPostIDs, data)
      })
    })
  }
}
